import {formDataToObject} from "../Helpers";
import {routePhotosCarouselInit} from "../routes/RoutePhotosGallery";

const RoutesSearch = function(selector){

    let form = $(selector);

    let formData = new FormData(form[0]);
    let obj = formDataToObject(formData);

    $.get({url: "/routes", cache: false}, obj, function(d){

        let data = JSON.parse(d);
        if(data.items.length > 0){

            let objectHist = {}

            if(obj.coordinates && obj.coordinates.length > 0) objectHist.coordinates = obj.coordinates;
            if(obj.radius && obj.radius.length > 0) objectHist.radius = obj.radius;
            if(obj.distance_min && obj.distance_min.length > 0) objectHist.distance_min = obj.distance_min;
            if(obj.distance_max && obj.distance_max.length > 0) objectHist.distance_max = obj.distance_max;
            if(obj.road_types && obj.road_types.length > 0) objectHist.road_types = obj.road_types;

            let strParamsHist = $.param(objectHist);
            let urlHist      = "/routes" + data.uri + (strParamsHist.length > 0 ? '?' + strParamsHist : '');

            if(window.histState){
                history.replaceState(null, null, urlHist);
            }else{
                history.pushState(null, null, urlHist);
                window.histState = true;
            }

            document.title = data.pageTitle;
            $('h1').text(data.h1);
            $('#page_description').html(data.description);
            $('.fullRouteContainer-speedbar').html(data.speedbar);

            const content = $('#ajaxContent');

            let clsLink3 = $('#clsLink3');
            content.html(data.items);

            routePhotosCarouselInit();

            if(clsLink3.length === 0){
                content.after(data.pagination);
                return;
            }

            clsLink3.replaceWith(data.pagination);
        }

    })

}

export {RoutesSearch}